import React from 'react';
import addModifiers from 'utils/add_modifiers';
import IlosUploadButton from './IlosUploadButton';

const IlosWebcamRecording = props => {
  const {
    loadIlosRecording,
    disabled,
    skipRecording,
    buttonStyles,
    showUploadButton,
    token,
  } = props;

  return (
    <div className="VideoResponseQuestion--webcamRecording">
      {showUploadButton && token && !disabled && (
        <IlosUploadButton token={token} />
      )}
      {!showUploadButton && (
        <button
          type="button"
          onClick={loadIlosRecording}
          className={buttonStyles}
          disabled={disabled}
        >
          {props.i18n.webcam_recording.turn_on}
        </button>
      )}
      <div
        className={
          !showUploadButton ? 'VideoResponseQuestion--topMargin' : null
        }
      >
        <span className="mr-4">
          {showUploadButton
            ? props.i18n.video_response.cannot_record
            : props.i18n.webcam_recording.no_webcam}
        </span>
        <button
          type="button"
          className={`VideoResponseQuestion-transparentButton pl-0 ${addModifiers(
            'NewButton',
            ['flat'],
          )}`}
          onClick={skipRecording}
          disabled={disabled}
        >
          {props.i18n.video_response.skip_action}
        </button>
      </div>
    </div>
  );
};

export default IlosWebcamRecording;
